<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_107_8928)">
      <path
        d="M18.3327 18.3335H1.66602"
        stroke="white"
        stroke-linecap="round"
        stroke-width="1.5"
      />
      <path
        d="M17.5 18.3335V12.0835C17.5 11.3932 16.9403 10.8335 16.25 10.8335H13.75C13.0597 10.8335 12.5 11.3932 12.5 12.0835V18.3335"
        opacity="0.5"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M12.5 18.3334V4.16675C12.5 2.98824 12.5 2.39898 12.1339 2.03286C11.7678 1.66675 11.1785 1.66675 10 1.66675C8.8215 1.66675 8.23223 1.66675 7.86612 2.03286C7.5 2.39898 7.5 2.98824 7.5 4.16675V18.3334"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M7.5 18.3334V7.91675C7.5 7.22639 6.94036 6.66675 6.25 6.66675H3.75C3.05964 6.66675 2.5 7.22639 2.5 7.91675V18.3334"
        opacity="0.5"
        stroke="white"
        stroke-width="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_107_8928">
        <rect
          fill="white"
          height="20"
          width="20"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'NlpWhoIsForIcon2',
}
</script>